import * as React from 'react';

import {LimitedGroup} from 'shells/limited-group/limited-group';
import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {shouldShowDelimiter} from 'shells/utils/should-show-delimiter';

import type {ExternalMeetingFragment_participants as MeetingParticipants} from 'nutshell-graphql-types';

import {translateApiTypeForLinkedEntity} from '../../helpers';

type Props = {
    participants: MeetingParticipants[];
};

export function ExternalMeetingParticipants(props: Props) {
    const models = props.participants.map((participant, index) => {
        const content =
            participant.emailAddress && participant.emailAddress.avatarEntity ? (
                <LinkedEntity
                    {...participant.emailAddress.avatarEntity}
                    greenLeads={true}
                    type={translateApiTypeForLinkedEntity(
                        participant.emailAddress.avatarEntity.__typename
                    )}
                />
            ) : (
                participant.name
            );

        return (
            <span
                className={index !== props.participants.length ? 'flex mr-4' : 'flex'}
                key={index}
            >
                {content}
                {shouldShowDelimiter(index, props.participants.length) ? ', ' : undefined}
            </span>
        );
    });

    return (
        <LimitedGroup
            models={models}
            isHoverable={true}
            shouldTruncate={true}
            shouldFlex={true}
            numDisplayed={2}
        />
    );
}
